import 'common/reset.scss';
import './index.scss';
import './wangEditor.scss';
import 'common/elementUi.js';
import MessageBox from 'common/message-box';
import Vue from 'vue';
import App from './App.vue';
import router from './router';
Vue.use(MessageBox);

new Vue({
  el: '#app',
  router: router,
  render: (h) => h(App)
});
